export function initEventCore( init: () => void ) {
    init();
}
